import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-statistics-dashboard',
    templateUrl: './statistics-dashboard.component.html',
    styleUrl: './statistics-dashboard.component.scss',
    standalone: false
})
export class StatisticsDashboardComponent implements OnInit {
  statisticsCardConfigs: StatisticsCardConfig[] = [{ name: 'Umowy', icon: 'description', route: '/statistics/worker-agreements', disabled: false }];

  ngOnInit() {}
}

interface StatisticsCardConfig {
  name: string;
  icon: string;
  route: string;
  disabled: boolean;
}
